import { render, staticRenderFns } from "./MimeInternetService.vue?vue&type=template&id=2bab3b51&scoped=true"
import script from "./MimeInternetService.vue?vue&type=script&lang=js"
export * from "./MimeInternetService.vue?vue&type=script&lang=js"
import style0 from "./MimeInternetService.vue?vue&type=style&index=0&id=2bab3b51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bab3b51",
  null
  
)

export default component.exports